<template>
  <div class="atividades-lavadorlancamentosCarro ml-4 mr-4">
    <b-row>
      <b-col cols="1" class="mb-4">
        <label for="input-live">Carro</label> 
        <b-form-input 
          id="carro" 
          v-model="lavagem.carro" 
          required 
          @click="reset()" 
          @keyup.enter="loadVeiculo()" 
          placeholder="Nº do carro"
        ></b-form-input>                                              
      </b-col>

      <b-col cols="2">
        <label class="ml-4" for="input-live">Placa</label> 
        <b-input-group-text>
          {{ veiculos.length > 0 ? veiculos.map(at => at.chassi).join(', ') : '-' }}
        </b-input-group-text>
      </b-col >

      <b-col cols="2">
        <label class="ml-4" for="input-live">Modelo Chassi</label> 
        <b-input-group-text>
          {{ veiculos.length > 0 ? veiculos.map(at => at.placa).join(', ') : '-' }}
        </b-input-group-text>
      </b-col>

      <b-col cols="2">
        <label class="ml-4" for="input-live">Denominação</label>
        <b-input-group-text>
          {{ veiculos.length > 0 ? veiculos.map(at => at.denominacao).join(', ') : '-' }}
        </b-input-group-text>
      </b-col>

      <b-col>
                <br>                
                <b-button size="sm" variant="success" class="mr-2 mt-2" block @click="gerarPlanilha()">
                  Planilha
                </b-button>                      
      </b-col>
    </b-row>

    <!-- Tabela de dados -->
    <b-table 
      id="id-lavagens"  
      small 
      hover 
      striped 
      sticky-header="880px"  
      :items="servicocarro" 
      :fields="fieldsCarro"
    >    

 
    </b-table>
  </div>
</template>
<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import * as XLSX from 'xlsx'
import moment from 'moment'
import { mapState } from 'vuex'

export default {    
  name: 'ManutencaoLavadorLancamento',    

  computed: { 
    ...mapState(['user']),
  },

  data() {
    return {            
      mode: 'save',

      empresas: [],
      filiais: [],
      tplavagens: [], // [] lista    
      origens: [], // [] lista    
      tplavagensc: [], // [] lista    

      lavagem: {},
      lavagensCarro: [], // Corrigido para usar 'lavagensCarro'
      veiculos: [],
      servicocarro:[],


      valor_empresa: [],
      valor_filial: [],
      value_status: [], // [] lista    
      value_lavagem: [], // [] lista    

      carregando: false,
      atualizando: false,            

      status: {},
      statuss: [], // [] lista            

      fieldsCarro: [        
        { key: 'denominacao', label: 'Serviço', sortable: true },                 
        { key: 'os_erp', label: 'Nº O.S', sortable: true },             
          { key: 'dt_emissao	', label: 'Emissão', sortable: true, formatter: (value, key, servicocarro) => {
          return moment(servicocarro.dt_emissao).format('DD/MM/YYYY').replace('Data inválida', '-'); 
        }},                                          
        { key: 'dt_inicio_servico', label: 'Inicio', sortable: true, formatter: (value, key, servicocarro) => {
          return moment(servicocarro.dt_inicio_servico	).format('DD/MM/YYYY - HH:mm').replace('Data inválida', '-'); 
        }},
        { key: 'dt_fim_servico	', label: 'Término', sortable: true, formatter: (value, key, servicocarro) => {
          return moment(servicocarro.dt_fim_servico	).format('DD/MM/YYYY - HH:mm').replace('Data inválida', '-'); 
        }},
        { key: 'id_limite', label: 'Limite', sortable: true },                                                                                          
        { key: 'km_executado', label: 'Km executado', sortable: true },              
        { key: 'km_atual2', label: 'Km atual', sortable: true },             
        { key: 'executante', label: 'Executante', sortable: true },
        { key: 'encarregado', label: 'Encarregado', sortable: true },      
        
      ]
    }        
  },

  components: {
    Multiselect
  },

  methods: {
    loadVeiculo() {
      let corpo = {    
        "empresa_id": `${this.user.id_empresa}`,
        "carro": `${this.lavagem.carro}`                 
      };
      const url = `${baseApiUrl}/jb/manutencao/frota/listagem`;
      axios.post(url, corpo)                      
        .then(res => { this.veiculos = res.data;
                  this.loadVeiculoServico()
         })                      
        .catch(showError);
    },

    loadVeiculoServico() {
      let corpo = {    
        "filtro": "appml18",
        "empresa_id": `${this.user.id_empresa}`,
        "carro_id": `${this.veiculos.map(at => at.id_carro).join(', ')}`                 
      };
      const url = `${baseApiUrl}/jb/preventiva/historico`;
      axios.post(url, corpo)                      
        .then(res => { 
            this.servicocarro = res.data;
    

         })                      
        .catch(showError);
    },

    gerarPlanilha() {
      // Objeto com os dados para a planilha
      const dados = this.servicocarro;
      // Cria uma nova planilha
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(dados);
      // Adiciona a planilha ao workbook
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Dados');
      // Salva o workbook como arquivo
      XLSX.writeFile(workbook, 'carro_servicos.xlsx');
    },



    formatarTempo(tempo) {
      if (!tempo || typeof tempo !== 'object') {
        return '-';
      }

      const { days = 0, hours = 0, minutes = 0, seconds = 0, milliseconds = 0 } = tempo;

      if (isNaN(days) || isNaN(hours) || isNaN(minutes) || isNaN(seconds) || isNaN(milliseconds)) {
        return '-';
      }

      const formatarComDoisDigitos = (num) => num.toString().padStart(2, '0');
      const milissegundosFormatado = Math.floor(milliseconds).toString().padStart(3, '0');
      const tempoFormatado = `${formatarComDoisDigitos(days)}:${formatarComDoisDigitos(hours)}:${formatarComDoisDigitos(minutes)}:${formatarComDoisDigitos(seconds)}`;

      return tempoFormatado;
    },

    reset() {            
      // Limpe os dados conforme necessário
    }
  },

  mounted() {
    // Qualquer lógica a ser executada após a montagem do componente
  }
}
</script>
